import { FormControlLabel, Switch, useTheme } from "@material-ui/core";
import { Brightness4, Brightness7 } from "@material-ui/icons";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { useHistory } from "react-router-dom";
// import { IconFlagES, IconFlagUK, IconFlagCA } from 'material-ui-flags';
import { US, ES, GA } from 'country-flag-icons/react/3x2'
import FlagES from "../../assets/icons/flags/ES.png";
import FlagUK from "../../assets/icons/flags/UK.png";
import FlagGAL from "../../assets/icons/flags/GAL.png";
import FlagCAT from "../../assets/icons/flags/CAT.png";
import FlagEUS from "../../assets/icons/flags/EUS.png";

import { useCommProvider } from "../../api/CommProvider";
import { useDataProvider } from "../../api/DataProvider";
import { pDB_user_roles } from "../../utils/parameters"



export function LanguageSwitcher(props) {
    
    const { i18n } = useTranslation();
    const { currentUser, currentUserRole, token_id, json_data_USER, set_json_data_USER } = useDataProvider();
    const { comm_updateSession } = useCommProvider();

    /* Check theme */
    useEffect(() => {

        // console.log('LanguageSwitcher USE EFFECT')
        if (json_data_USER !== null && json_data_USER !== undefined) {
            // console.log('LanguageSwitcher json_dta_USER Loaded')
            // console.log('LanguageSwitcher jsond data:', json_data_USER)
            // console.log('LanguageSwitcher json_data_USER.session:', json_data_USER.session)
            console.log('LanguageSwitcher language in json_data_USER.session:', 'language' in json_data_USER.session)

            if ('language' in json_data_USER.session === false){
                // console.log('LanguageSwitcher FALSE')
                // console.log('LanguageSwitcher USE DEFAULT')
                changeLanguage('es') 
            }else {
                // console.log('LanguageSwitcher TRUE')
                // console.log('LanguageSwitcher USE SPECIFIC:', json_data_USER.session.language)
                i18n.changeLanguage(json_data_USER.session.language); 
            }   
        }
    }, [json_data_USER])

    const history = useHistory();
    async function changeLanguage(newLanguage) {
        if (currentUserRole !== pDB_user_roles.invitated) {
            // console.log('LanguageSwitcher CHANGE LANGUAGE - comm_updateSession')
            const response = await comm_updateSession(token_id, currentUser, {'language': newLanguage})
            set_json_data_USER({...json_data_USER, session: {...json_data_USER.session, language: response['session']['language']}});
            //history.push({pathname: "/"})
        }else{
            i18n.changeLanguage(newLanguage)
        }
        
    };
    
    return (
        <div className="language-switcher">
            <FormControl>
                {/* <InputLabel id="language-select-label">Language</InputLabel> */}
                <Select
                    labelId="language-select-label"
                    id="language-select"
                    value={i18n.language}
                    onChange={(e) => changeLanguage(e.target.value)}
                    className="sig_Home_LanguageSwitch"
                >
                    <MenuItem className="sig_Home_LanguageItemSwitch" value="es"><img src={FlagES} className="sig_Home_LanguageFlag" alt="this is car image" /> </MenuItem>
                    <MenuItem className="sig_Home_LanguageItemSwitch" value="en"><img src={FlagUK} className="sig_Home_LanguageFlag" alt="this is car image" /> </MenuItem>
                    <MenuItem className="sig_Home_LanguageItemSwitch" value="cat"><img src={FlagCAT} className="sig_Home_LanguageFlag" alt="this is car image"/></MenuItem>
                    <MenuItem className="sig_Home_LanguageItemSwitch" value="eus"><img src={FlagEUS} className="sig_Home_LanguageFlag" alt="this is car image"/></MenuItem>
                    <MenuItem className="sig_Home_LanguageItemSwitch" value="gal"><img src={FlagGAL} className="sig_Home_LanguageFlag" alt="this is car image"/></MenuItem>
                </Select>
            </FormControl>
        </div>
    )
}